 import { styled } from "@mui/material/styles";

 const StyledEditProfile = styled("div")(
   ({ theme }) => `
    .edit-profile-wrap {
      display: flex;
      flex-direction: column;
      gap: 20px;
      width: 95.5%;
      height: 100%;
      @media screen and (max-width: 600px) {
        width: 100%;
      }
    }
    .edit-profile-header {
      font-family: Lexend;
      color: ${theme.palette.primary.main};
      font-weight: 500;
      font-size: 20px;
      font-style: normal;
      line-height: 100%;
      @media screen and (max-width: 600px) {
        display: none;
      }
    }
    .edit-profile-userinfo-wrap {
      max-height: 108px;
      background: ${theme.palette.customColor.white};
      padding: 26px 40px;
      border-radius: 0px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      flex-wrap: wrap;
      row-gap: 20px;
      @media screen and (max-width: 600px) {
        padding: 25px;
        margin: 0px 20px;
      }
    }
    .userinfo-dp-wrap {
      display: flex;
      gap: 20px;
      align-items: center;
    }
    .dp-picture-box {
      width: 54px;
      height: 54px;
      border-radius: 50%;
      overflow: hidden;
      border: 1px solid ${theme.palette.customColor.secondaryThird};
    }
    .profile-picture {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
    .userinfo-dp {
      display: flex;
      flex-direction: column;
      gap: 10px;
    }           
    .userinfo-dp-company {
      font-family: Lexend;
      color: ${theme.palette.primary.main};
      font-weight: 400;
      font-size: 18px;
      font-style: normal;
      line-height: 100%;
    }
    .userinfo-dp-email {
      font-family: Lexend;
      color: ${theme.palette.customColor.secondarySecond};
      font-weight: 400;
      font-size: 14px;
      font-style: normal;
      line-height: 100%;
    }
    .userinfo-info-wrap {
      display: flex;
      gap: 100px;
      align-items: center;
      @media screen and (max-width: 600px) {
        gap: 10px;
      }
    }
    .userinfo-name-wrap {
      display: flex;
      flex-direction: column;
      gap: 10px;
    }
    .userinfo-name-header {
      font-family: Lexend;
      color: ${theme.palette.customColor.secondarySecond};
      font-weight: 400;
      font-size: 12px;
      font-style: normal;
      line-height: 16px;
    }           
    .userinfo-name-body {
      font-family: Lexend;
      color: ${theme.palette.primary.main};
      font-weight: 400;
      font-size: 14px;
      font-style: normal;
      line-height: 100%;
    }
    .edit-profile-form-wrap {
      background: ${theme.palette.customColor.white};
      padding: 5px;
      border-radius: 0px;
      display: flex;
      align-items: stretch;
      min-height: 556px;
      height: auto;
      flex: 1;
    }
    .form-part-1 {
      width: 25%;
      background: #A78D7826;
      border-radius: 0px;
      display: flex;
      flex-direction: column;
      gap: 8px;
      align-items: end;
      padding: 10px 0px;
      height: auto;
      @media screen and (max-width: 600px) {
        display: none;
      }
    }
    .form-select-box {
      border-radius: 0px;
      padding: 10px 10px;
      width: 80%;
      cursor: pointer;
    }
    .selected {
      background: ${theme.palette.customColor.white};
    }  
    .form-part-2 {
      width: 70%;
      padding: 20px 30px;
      height: auto;
      flex: 1;
    }
    .text-feilds-2 {
      width: 49%;
    }
    .edit-profile-footer {
      width: 100%;
      display: flex;
      justify-content: flex-end;
      @media screen and (max-width: 600px) {
        justify-content: center;
        width: 90%;
        margin: -10px 20px 20px 20px;
      }
    }
    .submit-btn {
      width: 20%;
      padding: 10px;
      margin-top: 16px;
      font-size: 16px;
      text-transform: none;
      border-radius: 0px;
      @media screen and (max-width: 600px) {
        width: 100%;
      }
    }
    .edit-profile-mobile-choose-options {
      display: none;
      @media screen and (max-width: 600px) {
        gap: 10px;
        overflow-x: scroll;
        background: transparent;
        align-items: center;
        display: flex;
        border-bottom: 1px solid ${theme.palette.customColor.secondaryThird};
        padding: 0px 15px;
        margin-bottom: -20px;
      }
    }
    .mobile-options {
      min-width: 50%;
      padding: 10px 0px;
      background: transparent;
      cursor: pointer;
      text-align: center;
    }
    .mobile-selected {
      border-bottom: 2px solid ${theme.palette.secondary.main};
    }  
    .mobile-option-text {
      font-family: Lexend;
      color: ${theme.palette.primary.main};
      font-weight: 400;
      font-size: 14px;
      font-style: normal;
      line-height: 100%;
    }  
    .selected-mobile-text {
      color: ${theme.palette.secondary.main};
    }         
    .form-select-box-header {
      font-family: Lexend;
      color: ${theme.palette.primary.main};
      font-weight: 400;
      font-size: 14px;
      font-style: normal;
      line-height: 100%;
    }           
  
  `
 );

 export default StyledEditProfile;
